import React from 'react';
import Webcam from 'react-webcam';

const videoConstraints = {
    width: 312,
    height: 242,
    facingMode: "user"
  };
  
  const WebcamCapture = ({
    handleCaptureClick, webcamRef,
  }) => (
    <Webcam
      audio={false}
      height={242}
      screenshotFormat="image/jpeg"
      width={312}
      videoConstraints={videoConstraints}
      className='image-fluid'
      ref={webcamRef}
    >
      {/* {({ getScreenshot }) => (
        <button className="btn btn-dark mt-5 custom-input" id="captureBtn" onClick={handleCaptureClick}>Capture Image</button>
      )} */}
    </Webcam>
  );

export default WebcamCapture